var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "chat-input-container" },
    [
      _c(_setup.LexonTextAreaComponent, {
        staticClass: "chat-textarea",
        attrs: { placeholder: _setup.props.placeholder },
        nativeOn: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            )
              return null
            $event.preventDefault()
            return _setup.handleEnterKey.apply(null, arguments)
          },
        },
        model: {
          value: _setup.query,
          callback: function ($$v) {
            _setup.query = $$v
          },
          expression: "query",
        },
      }),
      _c(
        "v-btn",
        {
          class: ["send-btn", { "send-btn--active": _setup.query.trim() }],
          attrs: { elevation: "0", icon: "" },
          on: { click: _setup.handleButtonClick },
        },
        [
          !_vm.isLoading
            ? _c("img", {
                attrs: {
                  src: _setup.sendIcon,
                  alt: "Enviar",
                  width: "20",
                  height: "20",
                },
              })
            : _c("img", {
                attrs: {
                  src: _setup.stopIcon,
                  alt: "Cancelar",
                  width: "17",
                  height: "17",
                },
              }),
        ]
      ),
      _c(
        "div",
        { staticClass: "chat-toolbar" },
        [_c(_setup.ChatFilterComponent)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }